module.exports = __webpack_public_path__ + "img/v1-company.6313a489.png";